import { REGION_HOLIDAYS } from '../data/regions';
import { addDays, calendarDayDifference, parseLocalDate, startOfLocalDay } from './dateUtils';

function getHolidayRows(regionId = 'bayern') {
  return REGION_HOLIDAYS[regionId] || REGION_HOLIDAYS.bayern;
}

export function getPreparedHolidays(regionId = 'bayern') {
  return getHolidayRows(regionId).map(
    ([id, type, name, start, end]) => ({
      id,
      type,
      name,
      start,
      end,
      startDate: parseLocalDate(start),
      endDate: parseLocalDate(end)
    })
  );
}

export function getCurrentHoliday(now, regionId) {
  const day = startOfLocalDay(now);

  return getPreparedHolidays(regionId).find(
    ({ startDate, endDate }) => day >= startDate && day <= endDate
  ) || null;
}

export function getNextHoliday(now, regionId) {
  const day = startOfLocalDay(now);

  return getPreparedHolidays(regionId).find(
    ({ endDate }) => endDate >= day
  ) || null;
}

export function getFutureSummer(now, regionId) {
  return getPreparedHolidays(regionId).find(
    ({ type, startDate }) => type === 'summer' && startDate.getTime() > now.getTime()
  ) || null;
}

export function getUpcomingHolidays(now, regionId, count = 5) {
  const day = startOfLocalDay(now);

  return getPreparedHolidays(regionId)
    .filter(({ endDate }) => endDate >= day)
    .slice(0, count);
}

export function getRemainingFreeDays(now, holiday) {
  return holiday
    ? calendarDayDifference(startOfLocalDay(now), holiday.endDate) + 1
    : 0;
}

export function daysUntil(now, target) {
  return Math.max(0, calendarDayDifference(startOfLocalDay(now), target));
}

export function isHolidayDate(date, regionId) {
  return getPreparedHolidays(regionId).some(
    ({ startDate, endDate }) => date >= startDate && date <= endDate
  );
}

export function getEasterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  return new Date(year, month - 1, day);
}

export function getStatewideHolidays(year) {
  const easter = getEasterSunday(year);

  return [
    new Date(year, 0, 1),
    new Date(year, 0, 6),
    addDays(easter, -2),
    addDays(easter, 1),
    new Date(year, 4, 1),
    addDays(easter, 39),
    addDays(easter, 50),
    addDays(easter, 60),
    new Date(year, 9, 3),
    new Date(year, 10, 1),
    new Date(year, 11, 25),
    new Date(year, 11, 26)
  ];
}